import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Section = ({ title, items }) => (
  <section>
    <h3 className="text-sm font-bold text-[var(--cc-accent)] mb-1.5">{title}</h3>
    <ul className="text-sm space-y-1.5 text-[var(--cc-text-2)] list-disc pl-5">{items.map((t) => <li key={t}>{t}</li>)}</ul>
  </section>
);

const HOW = [
  "Tap Upload Video and pick a video from your phone or computer.",
  "Choose the spoken language (Auto, Hindi, English or Hinglish) and keep the recommended model.",
  "Tap Generate Captions. Approve the one-time model download. Wait for audio extraction and transcription.",
  "Fix words and timings in Captions, choose a look in Style, then download SRT (or try the video export) in Export.",
  "Best browsers: latest Chrome or Edge (desktop or Android). WebGPU makes the large model possible.",
];

const LIMITS = [
  "Accuracy depends on language, accent, background noise/music and model size. Hinglish and code-mixed speech is the hardest — always review.",
  "Whisper Large-v3 Turbo needs WebGPU (recent Chrome/Edge). Without it the app uses Whisper Small on CPU, which is slower and less accurate for Hindi.",
  "Transcription on CPU can take longer than the video itself; phones may run out of memory on long videos with big models.",
  "Whisper's Hinglish output may mix Devanagari and Latin script inconsistently; there's no automatic transliteration yet.",
  "Word-by-word highlighting uses evenly estimated word timings, not exact model word timestamps.",
  "Burned-in video export is real-time (as long as the video), outputs WebM on Chrome/Android (MP4 on Safari), and may stutter on weak phones. Keep the tab visible while exporting.",
  "Long silences, music or noise can produce hallucinated text; the app filters common cases and silent regions but cannot catch everything.",
  "Limits: 500 MB, 10 minutes per video. Formats are whatever your browser can play (MP4/H.264, WebM, MOV on most devices).",
];

export const InfoDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[var(--cc-panel)] max-w-lg max-h-[88vh] overflow-y-auto" data-testid="info-dialog">
      <DialogHeader>
        <DialogTitle>How CaptionCraft AI works</DialogTitle>
        <DialogDescription className="text-[var(--cc-text-2)]">Free, open-source, on-device. No API keys or subscriptions.</DialogDescription>
      </DialogHeader>
      <div className="space-y-5">
        <Section title="Quick start" items={HOW} />
        <Section title="Known limitations" items={LIMITS} />
        <Section title="Built with (all free & open-source)" items={["Transformers.js + ONNX Runtime Web (Whisper models from Hugging Face)", "Web Audio API, with FFmpeg.wasm fallback for audio extraction", "Canvas + MediaRecorder for burned-in export", "Google Fonts (100+ fonts incl. Devanagari)"]} />
      </div>
    </DialogContent>
  </Dialog>
);
